export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_4.5a0bf29f.png";